// Convierte "15/09/2001" → "2001-09-15"
export const convertToInputDateFormat = (ddmmyyyy) => {
  const [day, month, year] = ddmmyyyy.split("/");
  return `${year}-${month}-${day}`;
};

// Convierte "2001-09-15" → "15/09/2001"
export const convertToDisplayFormat = (yyyymmdd) => {
  const [year, month, day] = yyyymmdd.split("-");
  return `${day}/${month}/${year}`;
};
